import React,{useState} from 'react'
import DatePicker from "react-datepicker";
/* import { ko } from 'date-fns/esm/locale'; */
import "react-datepicker/dist/react-datepicker.css";

const SalesSearch = ({varSearchData,setSearchData,setPageNum,varBranchList,varYearList,varMonthList}) => {
  //항목별 검색변수값 설정
  const [varStartDate, setStartDate] = useState(varSearchData.sdate===null?null:varSearchData.sdate);
  const [varEndDate, setEndDate] = useState(varSearchData.edate===null?null:varSearchData.edate);
  const [varSearchBranch, setSearchBranch] = useState(varSearchData.searchBranch);
  const [varSearchYear, setSearchYear] = useState(varSearchData.searchYear);
  const [varSearchMonth, setSearchMonth] = useState(varSearchData.searchMonth);

  //검색항목 선택값 저장
  const onSearchBranchHandler = (e) => {   
    const bh_idx = Number(e.currentTarget.value);   
    setSearchBranch(bh_idx);
    setSearchData({...varSearchData,searchBranch:bh_idx});
    setPageNum(1);
  }
  //검색항목 선택값 저장
  const onSearchYearHandler = (e) => {   
    setSearchYear(Number(e.currentTarget.value));
  }
  //검색항목 선택값 저장
  const onSearchMonthHandler = (e) => {   
    setSearchMonth(Number(e.currentTarget.value));
  }

  //검색기간 설정값 저장
  const onChangeDateHandler = (ino,date) => {
    if(date === "" ) date = null;
    if(ino === 0) {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
  }

  //검색시작
  const onExecuteSearchingHandler = (e) => {
    e.preventDefault();
    setSearchData({sdate:varStartDate,edate:varEndDate,searchBranch:varSearchBranch,searchYear:varSearchYear,searchMonth:varSearchMonth});
    setPageNum(1);
  }

  //검색정보 초기화
  const onClearSearchHandler = (e) => {
    e.preventDefault();
    const ndate = new Date();
    const cyear = ndate.getFullYear();
    const cmonth = ndate.getMonth()+1;
    setSearchData({sdate:null,edate:null,searchBranch:0,searchYear:cyear,searchMonth:cmonth,searchOption:"all",searchString:""});
    setPageNum(1);
    setStartDate(null);
    setEndDate(null);
    setSearchBranch(0);
    setSearchYear(cyear);
    setSearchMonth(cmonth);
  }

  return (
    <div className="main-box" style={{height:"60px"}}>
      <div className="search-area" style={{position:"relative"}}>
        <div className="search-options" style={{position:"absolute",left:"0px",width:"20%"}}>
          <select value={varSearchBranch} style={{width:"150px"}} onChange={(e)=>onSearchBranchHandler(e)}>
            <option value={0}>센터 전체</option>
            {varBranchList.map((branchs,i)=>(
              <option key={'branchs_'+i} value={branchs.bh_idx}>{branchs.bh_company}</option>
            ))}
          </select>
        </div>
        <div className="search-string" style={{position:"absolute",right:"0px",width:"80%",display:"flex",justifyContent:"right"}}>
          <select value={varSearchYear} style={{width:"90px"}} onChange={(e)=>onSearchYearHandler(e)}>
            <option value={0}>년도 전체</option>
            {varYearList.map((years,i)=>(
              <option key={'years_'+i} value={years}>{years}</option>
            ))}
          </select>&nbsp;&nbsp;
          <select value={varSearchMonth} style={{width:"90px"}} onChange={(e)=>onSearchMonthHandler(e)}>
            <option value={0}>월 전체</option>
            {varMonthList.map((months,i)=>(
              <option key={'months_'+i} value={months}>{months}</option>
            ))}
          </select>&nbsp;&nbsp;
          <div className="datepicker_area" style={{display:"flex",justifyContent:"center",width:"300px"}}>
            <DatePicker /* locale={ko} */ name="sdate" className="datepicker" dateFormat="yyyy.MM.dd" selected={varStartDate} selectStart onChange={(date)=>onChangeDateHandler(0,date)} />
            ~
            <DatePicker /* locale={ko} */ name="edate" className="datepicker" dateFormat="yyyy.MM.dd" selected={varEndDate} selectEnd minDate={varStartDate} onChange={(date)=>onChangeDateHandler(1,date)} />   
          </div>&nbsp;&nbsp;
          <button style={{width:"90px"}} onClick={(e)=>onExecuteSearchingHandler(e)} className="btn">조회</button>
          <button style={{width:"90px"}} onClick={(e)=>onClearSearchHandler(e)} className="btn black">초기화</button>
        </div>
      </div>
    </div>
  )
}
export default SalesSearch;